/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../root'
import { RcmTable } from '../../../components/rcm-table/RcmTable'
import { TableHeadRow, TableHeadCell, TableRow } from '../../../components/table/TableComponents'
import type { FolderType } from '../../../services/api/api.foldertypes'
import { createDateTimeFormatter } from '../../../utils/commonColumns'
import TableMenu from './TableMenu'

interface FolderTypesTableProps {
  onRowClick: (folderType: FolderType) => void
  onDeleteSuccess?: () => void
  onExportStart?: () => void
  onExportEnd?: () => void
}

const FolderTypesTable: React.FC<FolderTypesTableProps> = ({
  onRowClick,
  onDeleteSuccess,
  onExportStart,
  onExportEnd
}) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  const formatDateTime = createDateTimeFormatter(context.service.auth, translate)

  return (
    <>
      <RcmTable
        className="chita-table"
        noResultsText={translate('NO_RESULTS_FILTERED')}
        HeadRow={
          <TableHeadRow className="has-actions">
            <TableHeadCell style={{ fontSize: '12px' }} sort="NAME">
              {translate('NAME')}
            </TableHeadCell>
            <TableHeadCell style={{ fontSize: '12px' }} id="0c8d9918-8fe0-4b5c-9a0b-892078c821f2">
              {translate('DESCRIPTION')}
            </TableHeadCell>
            <TableHeadCell style={{ fontSize: '12px' }} sort="CREATED_AT">
              {translate('CREATED_ON')}
            </TableHeadCell>
            <TableHeadCell style={{ fontSize: '12px' }} sort="CREATED_BY">
              {translate('CREATED_BY')}
            </TableHeadCell>
            <TableHeadCell style={{ fontSize: '12px' }} sort="UPDATED_AT">
              {translate('TABLE_TH_MODIFIED_ON')}
            </TableHeadCell>
            <TableHeadCell style={{ fontSize: '12px' }} sort="UPDATED_BY">
              {translate('TABLE_TH_MODIFIED_BY')}
            </TableHeadCell>
            <TableHeadCell style={{ fontSize: '12px' }} id="9ee7bd74-73f4-4d22-8bc7-225ea1afb094" className="actions">
              {translate('ACTIONS')}
            </TableHeadCell>
          </TableHeadRow>
        }
        Row={({ row }: { row: FolderType }) => {
          return (
            <TableRow key={row.id}>
              <td className="clipped-cell">
                <div className="ellipsis">
                  {row.system ? (
                    row.name
                  ) : (
                    <span className="btn-link" onClick={() => onRowClick(row)} style={{ cursor: 'pointer' }}>
                      {row.name}
                    </span>
                  )}
                </div>
              </td>
              <td>{row.description || translate('NOT_AVAILABLE')}</td>
              <td>{formatDateTime(row.createdAt)}</td>
              <td>{row.createdBy?.name || translate('NOT_AVAILABLE')}</td>
              <td>{formatDateTime(row.updatedAt)}</td>
              <td>{row.updatedBy?.name || translate('NOT_AVAILABLE')}</td>
              <td className="actions">
                <TableMenu
                  item={row}
                  onEdit={() => onRowClick(row)}
                  onDeleteSuccess={onDeleteSuccess}
                  onExportStart={onExportStart}
                  onExportEnd={onExportEnd}
                />
              </td>
            </TableRow>
          )
        }}
      />
    </>
  )
}

export default FolderTypesTable
